const flattenRoute = <T>(xs: T[], childSelector?: (item: T) => null | T[]): T[] =>
  xs.reduce<T[]>((acc, x) => {
    // console.log(x);
    let accConcat = acc.concat(x);
    const children = childSelector?.(x);
    if (children && children.length > 0) {
      accConcat = accConcat.concat(flattenRoute(children, childSelector));
    }
    return accConcat;
  }, []);

export { flattenRoute };
